import { Loader, LoaderCircle } from "lucide-react";

import * as styles from "./Spinner.css";

export function Spinner({
  size,
  icon = "loader-circle",
  className,
  ...props
}: {
  size?: number;
  icon?: "loader" | "loader-circle";
  className?: string;
}) {
  const IconComponent = icon === "loader" ? Loader : LoaderCircle;

  return (
    <IconComponent
      role="status"
      aria-label="Loading"
      size={size || 16}
      className={`${styles.spinner} ${className || ""}`}
      {...props}
    />
  );
}
